/**
 *
 * @param {object} data
 * @returns {[]}
 */
export default function (data = {}, sort = 'sales') {
  const result = [];
  // 遍历类别
  for (const key in data) {
    // 各类别数据
    const obj = {
      name: key,
      value: 0
    };
    if (sort === 'goods') {
      obj.value = data[key].length
    } else {
      // 遍历类别中的商品,累加销售额
      data[key].map(goods => obj.value += Number(goods[sort]));
    }
    result.push(obj);
  }
  result.sort((a, b) => {
    return b.value - a.value;
  });
  return result;
}
